import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3ed0734e/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "general-guidance"
    }}>{`General guidance`}</h2>
    <p><em parentName="p">{`Notifications`}</em>{` are messages that communicate information to the user.`}</p>
    <h2 {...{
      "id": "format"
    }}>{`Format`}</h2>
    <h4 {...{
      "id": "title"
    }}>{`Title`}</h4>
    <p>{`All notifications have subject titles, which should be short and descriptive. (Example: “Tester-app-02 has crashed.”)`}</p>
    <h4 {...{
      "id": "message"
    }}>{`Message`}</h4>
    <p>{`We recommend the body of the notification be contained within two lines. Be descriptive and include any troubleshooting actions or next steps. When possible, communicate the main message using just the title. You can include `}<a parentName="p" {...{
        "href": "/components/link/code"
      }}>{`links`}</a>{` within the notification body that redirect the user to next steps.`}</p>
    <h4 {...{
      "id": "dismissal"
    }}>{`Dismissal`}</h4>
    <p>{`We recommend that toast notifications automatically disappear after five seconds. Inline notifications are persistent until the user dismisses them. All notifications have at least one method of dismissal (typically, it is a small “x” in the upper right hand corner).`}</p>
    <h4 {...{
      "id": "icons"
    }}>{`Icons`}</h4>
    <p>{`Icons may provide additional clarity. Icons should be placed to the left of a title. These glyphs (16x16) can be found in the `}<a parentName="p" {...{
        "href": "/guidelines/icons/library"
      }}>{`icons`}</a>{` library.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "36.141304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsSAAALEgHS3X78AAAAkElEQVQoz2NgwAOeaFkwUA3cdTYE0y9cjZj22+iyMDBwMK620AaLiYmJkW7gdUVLiMGKVsJHFcykGVgYmP/rJ5NnGAj83CYKpv/vFhV5ulxUloFBnMPLWoyFbBcGrPEG04EbfMW957krApmcKpbKrGQbyDc/DEzzLgxn45sdwgFiC0WYkh+GIKC4NBhDjJBhACPaHIvdmYUGAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The three icon states",
            "title": "The three icon states",
            "src": "/static/e5a108195e4a219bf597139d8338c57e/fb070/notification-usage-1.png",
            "srcSet": ["/static/e5a108195e4a219bf597139d8338c57e/d6747/notification-usage-1.png 288w", "/static/e5a108195e4a219bf597139d8338c57e/09548/notification-usage-1.png 576w", "/static/e5a108195e4a219bf597139d8338c57e/fb070/notification-usage-1.png 1152w", "/static/e5a108195e4a219bf597139d8338c57e/c3e47/notification-usage-1.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2 {...{
      "id": "variations"
    }}>{`Variations`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Notification type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Toast notification`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Toasts are a non-modal, time-based window elements used to display short messages; they usually appear at the bottom of the screen and disappear after a few seconds.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Inline notification`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Inline notifications show up in task flows, to notify users of the status of an action. They usually appear at the top of the primary content area.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "high-vs-low-contrast"
    }}>{`High vs. low contrast`}</h3>
    <p>{`Use high-contrast style notifications for critical messaging. Low-contrast notifications are best used for supplemental messaging and are less visually disruptive to users. When in doubt, use the low contrast style.`}</p>
    <p>{`Inline and toast notifications can use different styles but you should never mix styles within the variations.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.08695652173913%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAB1UlEQVQoz6WQy0sbURTGr5kiiP+AdOUy10x84yMzkxkSJhNMJkLVhY4LxYWCf0ZxIS7cCRHqShBsceHauFOoba3W12hGow4qZuIjvmpQON57NaEuusqBj/Odey8/vnOR1hxEtDpG+ks6hw3X0MCgK9Ye46LRKCfLMidJ0n8liiJ7Q+SiDEVRGAsFOjRUbKmqWsKM4Gli9NZPSp+/LfBVDapfQqHQpKZpcZIgLggCk8/ne9dJQno/QdJNE/VRBksqeVo4Bu4MTrV16WB094DRa4BhGEDWZopEIqDHdOZ1XWczWQ8IAMLhMPUzbyt/QF5UyZI2NDdWeCuxx8vzbh57cJW7CoutApYECYs+ESuSjP2iHyt+mcwCrq+tww119e4abw1P9JEyqvlqhACAAWfnv5X+PtgsPwCnrKjPzMIjW3nOXhxNnH6/XzSXjxK7S3Zib9leu96z17NJ+8+NZa+/edrpbOaO7d2cndq6T91t3O6PU0by+YSjCRlwIb3yee0u6fw43zRXzjcs0q1fmR2ibWv10rR+OlvM0756sWMRIJVpPh5lth8OxygjBWnGKqxdTBUYeUM71fFTGjnwgK4ghy7gLzqBq9dzcNAZZNEhpAtv/1We8QJCehBO7nx9KAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "High vs. low contrast",
            "title": "High vs. low contrast",
            "src": "/static/ad82c625053caf0e774553730991deed/fb070/notification-usage-4.png",
            "srcSet": ["/static/ad82c625053caf0e774553730991deed/d6747/notification-usage-4.png 288w", "/static/ad82c625053caf0e774553730991deed/09548/notification-usage-4.png 576w", "/static/ad82c625053caf0e774553730991deed/fb070/notification-usage-4.png 1152w", "/static/ad82c625053caf0e774553730991deed/c3e47/notification-usage-4.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2 {...{
      "id": "placement"
    }}>{`Placement`}</h2>
    <h4 {...{
      "id": "toast-notifications"
    }}>{`Toast notifications`}</h4>
    <p>{`Toast notifications slide in and out a page from the top-right corner. Actionable notifications do not appear on mobile screen widths.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48.233695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAACJ0lEQVQoz4WRy4uSURjGrVUiEZEX1ERF3Q0VMZp4mRHps1qIKIIxbcZNi+iv6C9oN1SLooEJKlq0KrttU5nBaIayQR3z84K3z+to3+fn0zkHktlIB34873nPOc9533MUer0eOp3uv2i1WqjV6gUajYYpXTMajbLJZILBYEgoVCpVknCbsLGEO2eUysRFjea+w2Z7bLFYtihms3nLarUyHA7HI7vd/pAUZ1YAeEvYJuws4QXh+f7nLx8SHu8gEol0Y7GYEI/HhXA4LESj0TbHcaLf7/+ooINshiRJWDZkWWb642saHqcTHBcCd+MWQoT1QBBe3zr8awG43e7d8+fOnmaGw+FwQpBOMhgMGL1eT5LkmZR+n5rZbLa5z+OchwKuedC3Or++5pwHvVclr+sSMbz2S+9wnWKG5KBIwElGoxHG4zGIIfr9PvL7B9h+9gT3HuzgcvI13Hdf4Urypbyy+QYrG0+FVd/NTdZyuVxGPp8XS6USCoUCisUinSOTySCbzSKXy7F8iewrFg6RPeDxbreL1F6HaGf26fsIqVzvJ6mL+SlIeyCmYrVaRaPRYNCYXnB0dMSo1Wpo1OvEuIh69Td67SqEJg+hxcvHgxaNC9/20hcWn9JqtURBEFibFNpip9NBt9tFu91mbdM8nffpkwxH/5D/iBLVw/HxRMkMJ5MJKpWK1Gw2F+9HzXieR51URZWa0jytlJrSmF5KkKfTKdUSyXvIOetfm5Agla4qGDcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Toast notification example",
            "title": "Toast notification example",
            "src": "/static/0c404a3fc5c061a9ec56177d6f64b210/fb070/notification-usage-2.png",
            "srcSet": ["/static/0c404a3fc5c061a9ec56177d6f64b210/d6747/notification-usage-2.png 288w", "/static/0c404a3fc5c061a9ec56177d6f64b210/09548/notification-usage-2.png 576w", "/static/0c404a3fc5c061a9ec56177d6f64b210/fb070/notification-usage-2.png 1152w", "/static/0c404a3fc5c061a9ec56177d6f64b210/c3e47/notification-usage-2.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h4 {...{
      "id": "inline-notifications"
    }}>{`Inline notifications`}</h4>
    <p>{`Inline notifications appear near its related item. In `}<a parentName="p" {...{
        "href": "/components/form/code"
      }}>{`forms`}</a>{`, we recommend placing the inline notification at the bottom of the form, right before the submission buttons. Depending on the context of the page, inline notifications can appear above the content as well.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "113.45108695652175%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAACXBIWXMAAAsSAAALEgHS3X78AAADh0lEQVQ4y62V308TWRTHLyWj+COATSkPCi+u7EYwakiddoS2lLC7T+7Gt40ahWJM/PGuifjgf+BvNO7C22ZVJLtuQkIlMbsbsz9YjaJR1EqZTtvhzq/Oj2JrOx3P3EKUtGhIPMkn35vennPPOffMDEIfmNPpRJWsoaEBud1utCLz+XxEvV5vFU3T60Oh0Fq/37+up6dnTTabdczPzzs0TXPouu4wDIMAa+ID60/G3wDULlDzsT9mMpnKG9FolGg8Hl81PT3dJYqiN5fLtQMeyM4Ljh9CAwywYdmg6XS6ytZisdiYSqViYJhl2RQPBqXysM+rqrpIUi3ZN7YPaHXFLC3LQiu1ZX0gK6IY43qO435MJBJDNrIsX4bmX4CyLkLzbS4A54FrwLaFS3GUBYS0iebz+TpBEK7CAcMQ/CdboZ/DUPKwoiiLDAE/AzttH1DHx6qoWknJkEDlDUWWSSCzUHBDqU/hLl4Zuv4CLqQSz4E40G372PNZFpAVcKmXGWNVdHbWz2PcqWhaB5alDixJJV1YC6q6W9R1Pyh5tISFAV9ik+cuEr1/amD1w5HRLvbeH77Z8buM8ve/TPqfSeC/EpMPGHl8gsGjv3WKv4+RgOLIr+UBxfEJUrL+y0gj/+gxG596IiaePedUuHItkQQSnMYBqRSXfvGSlR9NScrjqa9tH/n/B59vDg3LqnyJWBDIRjaXc8ZYdpQXhNvwyN3QDeOWsZSbwA3gDuBZdg7Tb3OLWa5nReEkl0yeUXV9QFHVJaQ1bUBSlNPAWaCFtEtRyrOcuzlaeklcvV6f+fP+JfV17Jocmx1UZmIlYtygDEgz8cE3vHhlnheH9ATebvu84aXyDLN375FTtDtjLmvy4Vien5vIS3KkICuRgiRFijgWMflXkULyZcTSU+PAX5aaYEhVmbnygF+0tRHd2NS0ditN9+5ob+/f2toW3rJlc3jzV9vD1N6ZcPVBK1x9wAqjH6w+tNc6gr6zmonT98Xykjs7OsiPHo+nsTsU4uBNLfoDgTmfl8Y004WbDkVx0wkLNx8r4ObjJu/sN426XvNb26c+bJaPTVtra+mwPXuQy+Wi1tTUUC0tX1KBgJ8KBEMU6o5SiLEo1JWn0O4CtXq/SW06apIkXP1m5ZkKBoMrnkPX4eInP1JkzTAMKODdhWgmiNz7oqiu30L1fQWgiOqA2t5SZrV974O+A4TKiOlYCVkyAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Form example with inline notification",
            "title": "Form example with inline notification",
            "src": "/static/bc7db9718f6812de74fce21611b69977/fb070/notification-usage-3.png",
            "srcSet": ["/static/bc7db9718f6812de74fce21611b69977/d6747/notification-usage-3.png 288w", "/static/bc7db9718f6812de74fce21611b69977/09548/notification-usage-3.png 576w", "/static/bc7db9718f6812de74fce21611b69977/fb070/notification-usage-3.png 1152w", "/static/bc7db9718f6812de74fce21611b69977/c3e47/notification-usage-3.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      